import { useTranslation } from 'react-i18next';
import Button from '../../../../../common/widgets/Button';
import Dialog from '../../../../../common/widgets/Dialog';
import Icons from '../../../../../common/widgets/Icons';
import { resources } from '../../../resources/resources';

interface LimitErrorDetailsDialogProps {
  closeDialog: () => void;
}

export const LimitErrorDetailsDialog = (
  props: LimitErrorDetailsDialogProps,
) => {
  const { closeDialog } = props;
  const { t: translate } = useTranslation();
  return (
    <Dialog
      closeDialog={closeDialog}
      showCloseIcon
      closeOnClickOutside
      className="dialog-m error-dialog"
    >
      <div className="dialog-content">
        <h3 className="d-error-title">
          <Icons.DialogFunds />
          {translate(resources.products.limitErrorDialog.title)}
        </h3>
        <p className="d-error-text">
          {translate(resources.products.limitErrorDialog.message)}
        </p>
        <h3 className="d-error-tip-title">
          <Icons.DialogBenefitTip />
          {translate(resources.benefitTip)}
        </h3>
        <p className="d-error-tip-text">
          {translate(resources.products.limitErrorDialog.tip)}
        </p>
      </div>
      <div className="dialog-actions">
        <Button onClick={closeDialog} className="btn btn-outline">
          {translate(resources.close)}
        </Button>
      </div>
    </Dialog>
  );
};
